import { useFetch } from 'app/queryProvider';
import { IAppointmentReport } from '../types/Documents';
import { buildHistoryQueryString } from '../utils/historyQuery';

interface IAppointmentReportsResponse {
  results: IAppointmentReport[];
}

export const useAppointmentReports = (createdAtRanges?: string[] | null) => {
  const queryString = buildHistoryQueryString({ createdAtRanges, paginate: false });

  const { data, isLoading, isRefetching, refetch } = useFetch<IAppointmentReportsResponse>({
    url: queryString ? `?${queryString}` : '',
    queryKey: [['appointment-reports', queryString]],
    resource: { name: 'appointment-reports' },
  });

  return {
    appointmentReports: data?.results ?? [],
    isLoading,
    isRefetching,
    refetch,
  };
};
